import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen grid place-items-center p-6 text-center" data-testid="not-found-page">
      <div>
        <p className="font-brand text-6xl font-extrabold text-[#0B3D91] dark:text-white">404</p>
        <p className="mt-2 text-muted-foreground">Halaman tidak ditemukan.</p>
        <Button asChild className="mt-6" data-testid="not-found-home-link"><Link to="/">Ke halaman utama</Link></Button>
      </div>
    </div>
  );
}
